import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import adminApi from '../../../APIs/admin';
import UserInformation from '../../../components/UserDetails/UserInformation';
import UserProfile from '../../../components/UserDetails/UserProfile';
import { Divider, NavigateBack, Typography } from '../../../designComponents';
import { RootState } from '../../../store/selectors';
import { requestAPI } from '../../../utils';
import { ViewJobContainerStyled } from '../../BrowseJobs/BrowseJobDetails/style';

const UserDetails = () => {
  const { userId } = useParams();

  const singleUserData = useSelector(
    (state: RootState) => state.singleClientData,
  );

  const getSingleUserData = async () => {
    try {
      await requestAPI(adminApi.getSingleUser(userId || ''));
    } catch (error: any) {
      console.error(error);
      toast.error(error);
    }
  };
  useEffect(() => {
    getSingleUserData();
  }, []);

  return (
    <ViewJobContainerStyled>
      <div
        style={{
          position: 'sticky',
          top: '60px',
          zIndex: '999',
          paddingTop: '5px',
          background: '#fff',
        }}
      >
        <NavigateBack />
      </div>
      <div className="contents">
        <div className="heading">
          <Typography variant="title" className="heading">
            User Details{' '}
          </Typography>
        </div>
        <Divider spaceY="20px" />

        <UserProfile
          name={singleUserData?.fullName}
          email={singleUserData?.user.emailAddress}
          position={singleUserData?.permissions || 'Fire man'}
        />
        <Divider spaceY="20px" />

        <UserInformation
          userName={singleUserData?.fullName ?? ''}
          userType={singleUserData?.permissions || 'Fireman'}
          userEmail={singleUserData.user.emailAddress || ''}
          userAddress={singleUserData.userAddress || ''}
        />
        {/* <Divider spaceY="20px" />
        <AdditionalInformation />
        <Divider spaceY="20px" />
        <Actions /> */}
      </div>
    </ViewJobContainerStyled>
  );
};

export default UserDetails;
